import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useBackLink(fallback) {
  const route = useRoute()
  const router = useRouter()
  const back = window.history.state?.back
  const samePage = back && router.resolve(back).matched.at(-1)?.path === route.matched.at(-1)?.path
  const link = back && !samePage ? back : fallback
  return computed(() => ({ link, name: 'Back' }))
}
